import React, {Component} from 'react'
import {Link} from 'react-router'
import {extlink, outbound} from '../analytics/outbound'
import Radium from 'radium'
import Footer from '../footer'

const styles = {
  container: {
    fontSize: `1vw`,
    width: `100%`,
  },
  center: {
    width: `100%`,
    height: `70%`,
    display: `flex`,
    justifyContent: `center`,
    alignItems: `center`,
  },
  tile: {
    fontSize: `4vw`,
    textShadow: `2px 2px black`,
    display: `inline-block`,
    width: `33.333vw`,
    height: `26vw`,
    backgroundSize: `33.3333vw 26vw`,
    cursor: `pointer`,
    overflow: `hidden`,
    padding: `2vw`,
    margin: 0,
    color: `white`,
    textAlign: `center`,
    borderLeft: `1px solid #ccc`,
    borderRight: `1px solid #ccc`,
    borderBottom: `1px solid #ccc`,
    backgroundRepeat: `no-repeat`,

    //borderRadius: `5px`,
    opacity: 1.0,
    ':hover': {
      opacity: 0.9,
    },
    '@media (max-width: 900px)': {
      fontSize: `6vw`,
      width: `50vw`,
      height: `40vw`,
      backgroundSize: `50vw 40vw`,
    },
  },
}

class Home extends Component {
  render() {
    return <div style={styles.container}>
      <div key="tile_games" style={{...styles.tile, backgroundColor: `#007`, backgroundImage: `url('/images/if_Cryptography_422554.png')`}}>
        <div style={styles.center}>Cryptography</div>
      </div>
      <div key="tile_charity" style={{...styles.tile, backgroundColor: `#600`, backgroundImage: `url('/images/hackers_vr.jpg')`}}>
        <div style={styles.center}>Virtual Reality</div>
      </div>
      <div key="tile_labs" style={{...styles.tile, backgroundColor: `#066`, backgroundImage: `url('/images/if_electronic_brain_490385.png')`}}>
        <div style={styles.center}>Artifical Intelligence</div>
      </div>
      <Footer />
    </div>
  }
}

//        <img src="/images/electronic_brain-512.png" style={{width: `100%`, height: `100%`}} />

export default Radium(Home)



// WEBPACK FOOTER //
// ./src/home/index.js